import appData from '@/helpers/app-data'
import axios from 'axios'
import { eventBus } from '@/utils'
import airbrake from '@/helpers/airbrake'

const state = {
  results: appData.get('search'),
  loading: false
}

const mutations = {
  SET_LOADING (state, value) {
    state.loading = value
  },
  SET_RESULTS (state, results) {
    if (results.search_params.skip_geos) {
      results.geos = state.results.geos // keeping the previous geos since they were skipped by the search.
    }
    state.results = results
  },
  SET_FAILED (state, failed) {
    state.results.failed = !!failed
  }
}

function showError () {
  eventBus().$emit('notify', {
    group: 'main',
    type: 'error',
    title: 'Search is currently not available.',
    text: 'Please try again later',
    duration: 5000
  })
}
const actions = {
  showError,

  search ({commit}, searchParams = state.results.search_params) {
    if (searchParams) {
      if (searchParams.q && searchParams.q.trim().length > 0) {
        commit('SET_LOADING', true)
        return axios.get('/api/search', {params: searchParams, showProgress: true})
          .then(response => {
            const data = response.data
            commit('SET_LOADING', false)
            commit('SET_FAILED', false)
            commit('SET_RESULTS', data)
          })
          .catch(err => {
            commit('SET_LOADING', false)
            commit('SET_FAILED', true)
            showError()
            airbrake.notify(err)
          })
      } else {
        // blank search case, when the user hits the /search URL without query params
        // This clause is triggered when the user navigates to the /search URL using the
        // browser's nabigation buttons
        commit('SET_RESULTS', {
          maximum_result_count: state.results.maximum_result_count,
          search_params: {page: 1, skip_geos: false}
        })
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/search/index.js